import React, { useState } from 'react';
import { Upload, Button, message,Alert } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { InboxOutlined } from '@ant-design/icons';
import { parse } from '@loaders.gl/core';

import Language from 'components/language';
import { binaryToGeoJson } from '@loaders.gl/gis';
import { SHPLoader,ShapefileLoader } from '@loaders.gl/shapefile';
import { parseSHP } from '@loaders.gl/shapefile/dist/es5/lib/parsers/parse-shp';
import { parseShx } from '@loaders.gl/shapefile/dist/es5/lib/parsers/parse-shx';
import { parseDBF } from '@loaders.gl/shapefile/dist/es5/lib/parsers/parse-dbf';

const { Dragger } = Upload;

const parseGeometries = (geometries) => {
  const geojsonGeometries = [];
  for (const geom of geometries) {
    geojsonGeometries.push(binaryToGeoJson(geom, geom.type, 'geometry'));
  }
  return geojsonGeometries;
};
const joinProperties = (geometries, properties) => {
  const features = [];
  for (let i = 0; i < geometries.length; i++) {
    const geometry = geometries[i];
    const feature = {
      type: 'Feature',
      geometry,
      // properties can be undefined if dbfResponse above was empty
      properties: (properties && properties[i]) || {}
    };
    features.push(feature);
  }
  return features;
};
const ShapefileUploader=({onFinish})=>{
  const [fileList, setFileList] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [error,showError]=useState();
  
  // const handleParse=async()=>{      
    
  //   try{
  //     const { header: _header, geometries:_geometries } = parseSHP(uploadedFiles.shp);
  //     const geometries = parseGeometries(_geometries);
  //     // const shx        = parseShx(uploadedFiles.shx);
  //     const properties =  parseDBF(uploadedFiles.dbf);
  //     const _features  = joinProperties(geometries, properties);
  //     const features   = _features.filter(f=>f.geometry.type=="Polygon").map(f=>({...f,properties:{visible:true,name:f.properties?.name}}));
  //     console.log(features)
  //     setUploadedFiles({});
  //     showError();
  //     onFinish&&onFinish(features);
  //   }
  //   catch (error) {
  //     console.error('Error loading shapefile:', error);
  //     showError(error);
  //   }         
  // }
  
  const handleParse = async () => {
    try {
      const { header: _header, geometries: _geometries } = parseSHP(uploadedFiles.shp);
      const geometries = parseGeometries(_geometries);
      const properties = parseDBF(uploadedFiles.dbf);
      const _features = joinProperties(geometries, properties);
      
      // Include both Polygon and MultiPolygon geometries
      const features = _features
        .filter(f => f.geometry.type === "Polygon" || f.geometry.type === "MultiPolygon")
        .map(f => ({
          ...f,
          properties: { visible: true, name: f.properties?.name },
        }));
        
      console.log(features);
      setUploadedFiles({});
      showError();
      onFinish && onFinish(features);
    } catch (error) {
      console.error('Error loading shapefile:', error);
      showError(error);
    }
  };
  
  React.useEffect(()=>{
      // Check if all three required files (.shp, .dbf, .shx) have been uploaded.
      if (
        uploadedFiles.shp &&
        uploadedFiles.dbf
        
      ) {
        handleParse();               
      }
    },[uploadedFiles])
  
  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      
      const arrayBuffer = await file.arrayBuffer();
      const fileExtension = file.name.split('.').pop().toLowerCase();

      // Store the uploaded file based on its extension.
      setUploadedFiles((prevUploadedFiles) => ({
        ...prevUploadedFiles,
        [fileExtension]: arrayBuffer,
      }));
    
    

  
        onSuccess();
        setFileList([]);
      
    } catch (error) {
      console.error('Error loading shapefile:', error);
      onError(error);
    }
  };

  const onChange = ({ fileList }) => {
    // Update the state with the new fileList.
    setFileList(fileList);
  };
  const uploadProps =  {
      customRequest,
      fileList,
      onChange,
      accept:".shp, .dbf, .shx",
      multiple:true,
      beforeUpload:(file, fileList) => {          
        setFileList([]);
        setUploadedFiles({});
        return true;
      }
  }
  return (
    <div>
    <Dragger {...uploadProps}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text"><Language id="uploadmessage"/></p>
      <p className="ant-upload-hint">
        <Language id="shpimport"/>
      </p>
      
    </Dragger>        
    {error && 
        <Alert
          message="Error"
          description={error}
          type="error"            
          
        />
      }
      
      
    
    </div>
  );
}

export default ShapefileUploader;